// import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { getCurrentSite } from '../../utilities/site';

const useIsTW = () => {
  const intl = useIntl();
  const currentSite = getCurrentSite(intl.locale);
  const isTW = currentSite === 'tw';

  return isTW;
};

export default useIsTW;
